export default {
  login: {
    title: 'Auf meiner Seite anmelden',
    double_check_text: 'Anmeldung fehlgeschlagen. Bitte geben Sie die richtigen Daten ein.',
    id_email: 'ID/E-Mail-Adresse',
    password: 'Passwort',
    password_display: 'Passwort anzeigen',
    password_no_display: 'Passwort verbergen',
    login: 'Anmelden',
    keep_login_text: 'Login-Status beibehalten',
    forgot_password_text: 'Passwort vergessen',
    contact_us: 'Hier registrieren',
    asuene_service_outline: 'CO2-Visualisierung Cloud-Dienst "ASUENE"',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: 'GX/ESG Talentfokussierte Rekrutierungsplattform „ASUENE CAREER“',
    corporate_page: 'Unternehmens-Website',
    // cross_use: {
    //   title: '',
    //   asuene_product: {
    //     banner_title: '',
    //     flag_text: '',
    //     left_btn_label: '',
    //     left_btn_link: '',
    //     right_btn_label: '',
    //     right_btn_link: '',
    //   },
    //   footer_note: ''
    // }
  },
}
